/**
 * Permission names as the API accepts them on the wire.
 *
 * These are the `Action` enum CONSTANT names from the backend's permissions layer —
 * not its BRASS action strings ("LangHub Source Management" and friends), which are
 * internal to that layer and no part of this API's contract.
 *
 * Not generated from the GraphQL schema, deliberately. The schema types these as
 * strings rather than an enum so that a name the server does not model answers
 * `false` instead of failing the whole request — that is how client/server version
 * skew is absorbed. Modelling them as a GraphQL enum would turn skew into a
 * validation error, so the names live here instead.
 */
export const NamespacePermission = {
  /** View-only access to strings in a namespace. */
  View: 'VIEW',
  /**
   * Governs every source mutation in a namespace: creating a string group, creating
   * or editing strings, submitting or cancelling a translation, and rolling a version
   * back.
   */
  SourceManagement: 'SOURCE_MANAGEMENT',
} as const;

export type NamespacePermission =
  (typeof NamespacePermission)[keyof typeof NamespacePermission];
